import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { MatSidenav } from '@angular/material';
import { MediaMatcher } from '@angular/cdk/layout';
import * as Bowser from "bowser";

import { UiService } from './shared/services/ui.service';
import { LanguageService } from './shared/services/language.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    isRouteLoading: boolean;
    isTranslationLoading = true;

    isError: boolean;
    isValidBrowser: boolean;

    mode: string;
    isOpen: true;
    mobileQuery: MediaQueryList;

    private _mobileQueryListener: () => void;

    constructor(
        private uiSrv: UiService,
        private changeDetectorRef: ChangeDetectorRef,
        private media: MediaMatcher
    ) {
        this.mode = "side";
        this.mobileQuery = media.matchMedia('(max-width: 999px)');
        this._mobileQueryListener = () => changeDetectorRef.detectChanges();
        this.mobileQuery.addListener(this._mobileQueryListener);
    }

    ngOnInit() {
        this.initSubscriptions();
        this.checkBrowserVersion();
    }

    toggleSidenav(sidenav: MatSidenav, isToggle?: boolean): void {
        if(isToggle) {
            sidenav.toggle();
        } else if(this.mobileQuery.matches) {
            sidenav.close();
        }
    }

    hideInvalidBrowser(): void {
        this.isValidBrowser = true;
    }

    private initSubscriptions(): void {
        this.uiSrv.routeLoadingStateChanged
        .subscribe(loadingState => {
            this.isRouteLoading = loadingState;
        });

        this.uiSrv.translationLoadingStateChanged
        .subscribe(loadingState => {
            this.isTranslationLoading = loadingState;
        });
    }

    private checkBrowserVersion(): void {
        const browser = Bowser.getParser(window.navigator.userAgent);
        this.isValidBrowser = browser.satisfies({
          chrome: ">=71",
          firefox: ">=64",
          safari: ">=11",
          "Microsoft Edge": ">=17"
        });
        this.isValidBrowser = true;
    }
}
